import { createContext, ComponentType, useState } from 'react';
import axios from 'axios';
import { Localize } from '@hilma/netina2all';

interface ItemsContextProviderValue {
    selectedItems: { [key: string]: number };
    setSelectedItems: React.Dispatch<React.SetStateAction<{ [key: string]: number }>>;
    getItemInfo: () => Promise<void>;
    showErr: boolean;
    itemsResponse: Localize<ItemsResponse>[] | null;
}

export interface ItemsResponse {
    id: number;
    name: string;
    price: number;
    donationPercent: string;
    isForNeedy: boolean;
    imagePath: string;
    description: string;
}

interface ChildrenProps {
    children: React.ReactNode;
}

export const ItemsContext = createContext<ItemsContextProviderValue | null>(null)

export const ItemsProvider: ComponentType<ChildrenProps> = ({ children }) => {

    const [selectedItems, setSelectedItems] = useState<{ [key: string]: number }>({});
    const [showErr, setShowErr] = useState(false);
    const [itemsResponse, setItemsResponse] = useState<Localize<ItemsResponse>[] | null>(null);

    const getItemInfo = async () => {
        if (itemsResponse !== null) return;

        try {
            const res = await axios.get<Localize<ItemsResponse>[]>('/api/item/purchase')

            setItemsResponse(res.data)

        } catch (err) {
            setShowErr(true)
        }
    }

    return (
        <ItemsContext.Provider value={{ selectedItems, setSelectedItems, getItemInfo, showErr, itemsResponse }}>
            {children}
        </ItemsContext.Provider>
    )
}